import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CheckboxSetting from '../settings/CheckboxSetting';
import { Form, Row } from 'react-bootstrap';
import { YesNoFieldModel, YesNoNaType } from '../../../../../../models/form/fields/yesNo';
import SelectSetting from '../settings/SelectSetting';
import ColorSetting from '../settings/ColorSetting';
import { updateSelectedField, selectedFieldSelector } from '../../../../../../slices/formadmin';
import CultureTextSetting from '../settings/CultureTextSetting';
import { RootState } from '../../../../../../store';

const YesNoProperties: FC = () => {
  const field = useSelector(selectedFieldSelector) as YesNoFieldModel;
  const selectedLanguage = useSelector((state: RootState) => state.formAdmin.selectedLanguage) as string;
  const dispatch = useDispatch();

  let options;
  if (field.allowNa) {
    options = [
      { text: 'Yes', value: 'yes' },
      { text: 'No', value: 'no' },
      { text: 'N/A', value: 'na' },
    ];
  } else {
    options = [
      { text: 'Yes', value: 'yes' },
      { text: 'No', value: 'no' },
    ];
  }

  return (
    <Form>
      <Row className="align-items-center">
        <CultureTextSetting
          id={`field.${field.id}.text`}
          culture={selectedLanguage}
          value={field.text}
          label="adminProperties.fields.common.text"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                text: val,
              }),
            )
          }
        />
        <ColorSetting
          value={field.textColor}
          label="adminProperties.fields.common.textColor"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                textColor: val,
              }),
            )
          }
        />
        <CheckboxSetting
          id={field.id + 'hiddenText'}
          checked={field.hiddenText}
          label="adminProperties.fields.common.hiddenText"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                hiddenText: val,
              }),
            )
          }
        />
      </Row>
      <Row>
        <CheckboxSetting
          id={field.id + 'required'}
          checked={field.required}
          label="adminProperties.fields.common.required"
          size={6}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                required: val,
              }),
            )
          }
        />
        <CheckboxSetting
          id={field.id + 'enabled'}
          checked={field.enabled}
          label="adminProperties.fields.common.enabled"
          size={6}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                enabled: val,
              }),
            )
          }
        />
      </Row>
      <Row>
        <CheckboxSetting
          id={field.id + 'visible'}
          checked={field.visible}
          label="adminProperties.fields.common.visible"
          size={6}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                visible: val,
              }),
            )
          }
        />
        <CheckboxSetting
          id={field.id + 'excludeFromReport'}
          checked={field.excludeFromReport}
          label="adminProperties.fields.common.excludeFromReport"
          size={6}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                excludeFromReport: val,
              }),
            )
          }
        />
        <CheckboxSetting
          id={field.id + 'allowNa'}
          checked={field.allowNa}
          label="adminProperties.fields.yesNo.allowNa"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                allowNa: val,
              }),
            )
          }
        />
        <SelectSetting
          options={options}
          label="adminProperties.fields.yesNo.defaultValue"
          size={6}
          value={field.defaultValue}
          onChange={(val) => {
            dispatch(
              updateSelectedField({
                ...field,
                defaultValue: val as YesNoNaType,
              }),
            );
          }}
        />
      </Row>
    </Form>
  );
};

export default YesNoProperties;
